// Checks that all required parameters are available on object of type K.
export function validateParams(params, requiredParams) {
    return requiredParams.every((param)=>!!params[param]
    );
}

//# sourceMappingURL=validate-params.js.map